import { useNavigate } from "react-router-dom";
import { Popover, PopoverProps } from "..";
import * as S from "./HeaderPopover.style";
import { ReactComponent as IconProfile } from "@/styles/assets/svg/icon_menu05_filled.svg";

interface HeaderPopoverProps extends PopoverProps {}

export const HeaderPopover = ({ setPopover }: HeaderPopoverProps) => {
  const navigate = useNavigate();

  return (
    <Popover setPopover={setPopover}>
      <S.HeaderPopover>
        <S.PopoverList>
          <S.PopoverItem onClick={() => navigate("/auth/profile/select")}>
            <IconProfile />
            프로필 변경
          </S.PopoverItem>
        </S.PopoverList>
      </S.HeaderPopover>
    </Popover>
  );
};
